<div class="frames" *ngIf="event != null">
  <ion-item class="frame" lines="none" id="event__{{ event.id }}">
    <div class="content">
      <div class="line">
        <div class="description w100 left">
          <p class="subtitle">
            {{ event.type?.name }}<ion-chip *ngIf="event.amount(comptaService) > 0"
              style="float: right; margin-top: -5px;" color="success">{{ event.amount(comptaService) |
              currency:'EUR':'symbol':'1.2-2':'fr-FR' }}</ion-chip>
            <ng-container *ngIf="event.type?.isTreatment">
              <ion-label color="danger" *ngIf="event.statut?.id == 'done' && !event.treatmentIsSuccess"
                style="float: right; font-style: italic;">{{ 'The treatment failed.' | translate }}</ion-label>
              <ion-label color="success" *ngIf="event.statut?.id == 'done' && event.treatmentIsSuccess"
                style="float: right; font-style: italic;">{{ 'The treatment was successful.' | translate }}</ion-label>
              <ion-label color="warning" *ngIf="event.statut?.id == 'validated' && event.dateTimeStartIsPast(dateUtils)"
                style="float: right; font-style: italic;">{{ 'Treatment in progress.' | translate }}</ion-label>
            </ng-container>
          </p>
          <p class="date">{{ dateUtils.datefusion_full(dateUtils.fromString(event.dateTimeStart),
            dateUtils.fromString(event.dateTimeEnd)) }}</p>
        </div>
      </div>
      <div class="line" *ngIf="event.comment && event.comment.length > 0">
        <div class="description w100 left comment">
          <p class="data">{{event.comment}}</p>
          <p *ngIf="event.documents">
            <ion-label>
              <span *ngFor="let d of event.documents; let index = index">
                <span *ngIf="index > 0">, </span><span class="action fileLink"
                  (click)="setModalDisplayDocumentDocument(d);modalDisplayDocument.present()">{{ d.name }}</span>
              </span>
            </ion-label>
          </p>
        </div>
      </div>
      <div class="line">
        <div class="description w100 left">
          <ion-chip style="padding-left: 0;" class="noBackground" color="danger"
            *ngIf="(event.statut?.id ?? 'canceled') == 'canceled'">{{ 'Canceled' | translate }}</ion-chip>
          <ion-chip style="padding-left: 0;" class="noBackground" color="success"
            *ngIf="(event.statut?.id ?? 'validated') == 'validated' && !event.type?.isTreatment">{{ 'Validated' |
            translate }}</ion-chip>
          <ion-chip style="padding-left: 0;" class="noBackground" color="success"
            *ngIf="(event.statut?.id ?? 'validated') == 'validated' && event.type?.isTreatment && event.dateTimeStartIsPast(dateUtils)">{{
            'In progress' | translate }}</ion-chip>
          <ion-chip style="padding-left: 0;" class="noBackground" color="success"
            *ngIf="(event.statut?.id ?? 'validated') == 'validated' && event.type?.isTreatment && !event.dateTimeStartIsPast(dateUtils)">{{
            'planned' | translate }}</ion-chip>
          <ion-chip style="padding-left: 0;" class="noBackground" color="danger"
            *ngIf="(event.statut?.id ?? 'tobeconfirmed') == 'tobeconfirmed'">{{ 'To be confirmed' | translate
            }}</ion-chip>
          <ion-chip style="padding-left: 0;" class="noBackground" color="medium"
            *ngIf="(event.statut?.id ?? 'done') == 'done'">{{ 'Finished' | translate }}</ion-chip>

          <ng-container *ngFor="let animal of event.animals">
            <div class="chip notoppadding noBackground"
              (click)="closeEvent.emit();router.navigate(['animal-fiche/', animal.id]);$event.stopPropagation();"
              style="cursor: pointer;">
              <img src="{{animal.avatarBase64}}" class="avatar" *ngIf="animal.avatar">
              <img src="/assets/icon/animal.png" class="avatar" *ngIf="!animal.avatar">
              <div>{{animal.name}}</div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ion-item>


  <ng-container *ngFor="let animal of event.animals">
    @let report = getReportOfAnimal(event, animal);
    <ng-container *ngIf="report">
      <ion-item class="frame" lines="none">
        <div class="line">
          <div class="description w100 left">
            <div class="chip notoppadding"
              (click)="router.navigate(['animal-fiche/', animal.id]);$event.stopPropagation();"
              style="cursor: pointer;">
              <img src="{{animal.avatarBase64}}" class="avatar" *ngIf="animal.avatar">
              <img src="/assets/icon/animal.png" class="avatar" *ngIf="!animal.avatar">
              <div>{{animal.name}}</div>
            </div>
            <ion-chip *ngIf="report?.weight" style="float: right;">{{ report?.weight }} {{ 'kg' | translate
              }}</ion-chip>
          </div>
        </div>
        <div class="line">
          <div class="description w100 left">
            <div *ngIf="report?.report" class="report">
              <p>
                <span *ngIf="(report?.diseases?.length ?? 0) > 0" class="chip">
                  <ng-container *ngFor="let d of report?.diseases; let index = index">
                    <img src="/assets/icon/disease.png" class="avatar">{{d.disease?.name}}
                  </ng-container>
                </span>
                <span *ngIf="(report?.surgicalOperations?.length ?? 0) > 0" class="chip">
                  <ng-container *ngFor="let d of report?.surgicalOperations; let index = index">
                    <img src="/assets/icon/operation.png" class="avatar">{{d.surgicalOperation?.name}}
                  </ng-container>
                </span>
                <span *ngIf="report?.isNothingToReport" class="chip">
                  <img src="/assets/icon/heart.png" class="avatar" style="border-width: 0px; margin-right: 0.5em;">{{
                  'Nothing to report' |
                  translate }}
                </span>
              </p>
              <p *ngIf="report?.vaccines">
                <ng-container *ngFor="let vaccine of report?.vaccines; let index = index"><span *ngIf="index > 0">,
                  </span>{{vaccine.label?.name}}</ng-container>
              </p>
              <p *ngIf="!report?.isNothingToReport && report?.report" class="title">
                <span class="title"><img src="/assets/icon/info.png">{{ 'Report' | translate }}</span>
              </p>
              <p *ngIf="!report?.isNothingToReport">
                {{ report?.report }}
              </p>
              <p *ngIf="report?.treatment" class="title">
                <span class="title"><img src="/assets/icon/treatment.png">{{ 'Treatment' | translate }}</span>
              </p>
              <p *ngIf="report?.treatment">
                <span class="white-space">{{ report?.treatment?.comment }}</span>
              </p>
              <p *ngIf="report?.documents">
                <ion-label>
                  <span *ngFor="let d of report?.documents; let index = index">
                    <span *ngIf="index > 0">, </span><span class="action fileLink"
                      (click)="setModalDisplayDocumentDocument(d);modalDisplayDocument.present()">{{ d.name }}</span>
                  </span>
                </ion-label>
              </p>
            </div>
          </div>
        </div>
      </ion-item>
    </ng-container>
  </ng-container>
</div>


<ion-modal #modalDisplayDocument>
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button (click)="modalDisplayDocument.dismiss()" [strong]="true">{{ 'Close' | translate }}</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding *ngIf="modalDisplayDocumentDocument != null">
      <ion-item lines="none">
        <ion-label>{{ modalDisplayDocumentDocument['name'] }} </ion-label>
      </ion-item>
      <ion-item lines="none">
        <img src="{{modalDisplayDocumentDocumentBase64}}" style="width: 100%; height: auto;">
      </ion-item>
    </ion-content>
  </ng-template>
</ion-modal>